import { isIOS } from "../utilities/globalUtilities";
const scrollLock = require("../utilities/scrollLock");

var $body = $("body");
var $minicart = $(".minicart");
var $miniCartModalBg = $(".js-modal-bg-minicart");
var $minicartPopover = $(".minicart .ct-popover");

var $cache = {
    mainMenu: $(".main-menu"),
    modalBackground: $(".js-modal-bg"),
    html: $("html")
};

/*
 ** @description: Function that will toggle the mobile menu
 * @param {Boolean} isResized - browser resize action
 */
const mobileMenuButtonToggle = isResized => {
    const toggleOff = isResized ? true : $(".navigation-open").length > 0;
    const $minicartIsOpen = $(".minicart .ct-popover").hasClass("show");
    const $userNavItem = $(".user.nav-item.d-block");

    if ($minicartIsOpen) {
        hideMiniCart();
    }

    $(".navbar-toggler").toggleClass("d-none", !toggleOff);
    $(".navbar-toggler.close-nav").toggleClass("d-none", toggleOff);
    $(".main-navigation-wrapper").toggleClass("active-menu", !toggleOff);
    $(".main-menu-wrapper").toggleClass("active-menu", !toggleOff).toggleClass("is-sticky-navigation", $cache.html.hasClass("sticky-navigation")).toggleClass("is-ios", isIOS());
    $cache.mainMenu.toggleClass("d-none", toggleOff);
    $("body").toggleClass("modal-open", !$(".modal-open").length && !toggleOff).toggleClass("navigation-open", !toggleOff);

    if ($(".modal-open").length) {
        scrollLock.enable();
        $userNavItem.removeClass("is-logged-header-menu");
    } else {
        scrollLock.disable();
    }

    if (!toggleOff) {
        $cache.modalBackground.addClass("header-visible").show();
    } else {
        $cache.modalBackground.removeClass("header-visible").hide();
    }

    return;
};

const  hideMiniCart = () => {
    $body.removeClass("minicart-opened");
    scrollLock.disable();
    $minicartPopover.removeClass("show");
    $minicart.removeClass("is-open");
    $miniCartModalBg.hide();
};


export { mobileMenuButtonToggle };
